import { Typography } from '@material-ui/core';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import PropTypes from 'prop-types';
import React from 'react';
import { globalStyles } from './style/gstheme';
import { isRTL } from './utils/utils';

const styles = () => {
  return Object.assign({
    listResultItem: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between'
    }
  }, globalStyles);
};

class SelectableListResult extends React.Component {

  render() {

    const { classes, onClick, invalid, iri, pendingDeletion, additionalLabel, selectable, text, listSecondIcon, lang } = this.props;
    const rtl = isRTL(lang);

    return (
      <ListItem
        data-test={invalid ? "list-item-invalid" : "list-item"}
        className={((invalid && !selectable) || pendingDeletion) ? classes.invalidResult : classes.result}
        dir={rtl ? "rtl" : null}
        style={{ ...(rtl) && { textAlign: 'right' } }}>
        <ListItemText disableTypography className={classes.resultText}
          primary={
            <div className={classes.listResultItem}>
              <div style={{ width: '100%' }}>
                <Typography
                  data-test="list-item-text"
                  lang={lang}
                  variant="body2"
                  style={{ wordWrap: 'break-word' }}>
                  <Tooltip title={iri}><span>{text}</span></Tooltip>
                </Typography>
                {(additionalLabel || pendingDeletion) &&
                  <div>
                    {additionalLabel && !pendingDeletion && <Typography data-test="additional" variant="caption">{additionalLabel}</Typography>}
                    {pendingDeletion &&
                      <div>
                        <Typography data-test="caption" variant="caption">This is pending deletion and will be removed shortly.</Typography>
                        <Typography variant="caption">Once removed the IRI becomes available for reuse.</Typography>
                      </div>}
                  </div>
                }
              </div>
              <div
                data-test="second-icon"
                className={classes.resultSecondIcon}
                style={{ ...(rtl) && { textAlign: 'left' } }}>
                {listSecondIcon}
              </div>
            </div>
          }
          onClick={onClick} />
      </ListItem>
    );
  }
}

SelectableListResult.defaultProps = {
  invalid: false,
  selectable: false,
  pendingDeletion: null
};

SelectableListResult.propTypes = {
  invalid: PropTypes.bool,
  selectable: PropTypes.bool,
  lang: PropTypes.string.isRequired,
  iri: PropTypes.string.isRequired,
  pendingDeletion: PropTypes.bool,
  text: PropTypes.string.isRequired,
  listSecondIcon: PropTypes.object,
  onClick: PropTypes.func,
  additionalLabel: PropTypes.any,
  classes: PropTypes.object
};

export default withStyles(styles)(SelectableListResult);